import React, { useState } from "react";
import { AUDIT_ACTION_LABELS } from "../../types";
import { formatDateTime } from "../../lib/date";
import { useQuery } from "@tanstack/react-query";
import api from "../../api/client";
import type { AuditLog, ApiList } from "../../types";

export default function AuditPage() {
  const [page, setPage] = useState(1);
  const [entity, setEntity] = useState("");
  const [action, setAction] = useState("");

  const { data, isLoading } = useQuery({
    queryKey: ["audit", page, entity, action],
    queryFn:  () => api.get<ApiList<AuditLog>>(
      `/audit?page=${page}&pageSize=30${entity ? `&entity=${entity}` : ""}${action ? `&action=${action}` : ""}`
    ).then(r => r.data),
  });

  const logs  = data?.data  ?? [];
  const meta  = data?.meta;

  const ACTION_LABELS: Record<string, string> = AUDIT_ACTION_LABELS;

  const ENTITY_OPTIONS = ["MealEntry","OrgHeadcount","Item","ItemCategory","SystemSetting","Report","User","Governorate","Directorate","Restaurant"];

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">سجل التدقيق</h1>
        <p className="page-subtitle">جميع العمليات والتغييرات في النظام</p>
      </div>

      <div className="card mb-4 flex flex-wrap gap-4">
        <div>
          <label className="label">الكيان</label>
          <select className="input w-40" value={entity} onChange={e => { setEntity(e.target.value); setPage(1); }}>
            <option value="">الكل</option>
            {ENTITY_OPTIONS.map(e => <option key={e} value={e}>{e}</option>)}
          </select>
        </div>
        <div>
          <label className="label">الإجراء</label>
          <select className="input w-36" value={action} onChange={e => { setAction(e.target.value); setPage(1); }}>
            <option value="">الكل</option>
            {Object.entries(ACTION_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </div>
      </div>

      {isLoading && <p className="text-center text-gray-400 py-8">جاري التحميل...</p>}

      <div className="table-container">
        <table className="table text-xs">
          <thead>
            <tr><th>الوقت</th><th>المستخدم</th><th>الإجراء</th><th>الكيان</th><th>#</th><th>الملخص</th><th>IP</th></tr>
          </thead>
          <tbody>
            {logs.length === 0 ? (
              <tr><td colSpan={7} className="text-center text-gray-400 py-6">لا توجد سجلات</td></tr>
            ) : logs.map(l => (
              <tr key={l.id}>
                <td className="text-gray-400 whitespace-nowrap"><span dir="ltr">{formatDateTime(l.at)}</span></td>
                <td>{l.user?.fullName ?? "—"}</td>
                <td><span className="badge bg-blue-50 text-blue-700">{ACTION_LABELS[l.action] ?? l.action}</span></td>
                <td><code className="text-gray-500">{l.entity}</code></td>
                <td>{l.entityId ?? "—"}</td>
                <td className="max-w-xs truncate text-gray-600">{l.summary ?? "—"}</td>
                <td className="text-gray-400">{l.ipAddress ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {meta && meta.totalPages > 1 && (
        <div className="flex items-center justify-between mt-4 text-sm text-gray-600">
          <span>الإجمالي: {meta.total} سجل</span>
          <div className="flex gap-2">
            <button className="btn-secondary py-1 px-3 text-xs" onClick={() => setPage(p => p-1)} disabled={page===1}>السابق</button>
            <span className="py-1 px-3 text-xs">صفحة {page} / {meta.totalPages}</span>
            <button className="btn-secondary py-1 px-3 text-xs" onClick={() => setPage(p => p+1)} disabled={page===meta.totalPages}>التالي</button>
          </div>
        </div>
      )}
    </div>
  );
}
